import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SettingsName } from "@app/class/SettingsName";
import { IAccountUserMapping } from "@app/interfaces/IUser";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { IAccountUserMappingUpdate } from "./accountUserMapping.service.ajs";
import { ConstantsService } from "./constantsService";
import { SessionService } from "./session.service";
import { TranslationService } from "./translation.service";

@Injectable({
    providedIn: 'root'
})
export class AccountUserMappingService {
    isDemoSite: boolean;
    constructor(
        private readonly http: HttpClient,
        private readonly constantsService: ConstantsService,
        private readonly sessionService: SessionService,
        private readonly translationService: TranslationService
    ) {
        this.isDemoSite = this.constantsService.getIsDemoSite();
    }

    getAccountUserMappings(): Observable<IAccountUserMapping[]> {
        return this.http.get<IAccountUserMapping[]>(`/api/userAccountMappings`)
            .pipe(map(mappings => {
                return this.formatMappings(mappings);
            }))
    }

    getAccountUserMappingsForAccount(accountId: number): Observable<IAccountUserMapping[]> {
        return this.http.get<IAccountUserMapping[]>(`/api/userAccountMappings/${accountId}`)
            .pipe(map(mappings => {
                return this.formatMappings(mappings);
            }))
    }

    getCurrentAccountUserMappings(): Observable<IAccountUserMapping[]> {
        return this.http.get<IAccountUserMapping[]>(`/api/userAccountMappings/current`)
            .pipe(map(mappings => {
                return this.formatMappings(mappings);
            }))
    }

    postAccountUserMapping(email: string, accountUserMapping: IAccountUserMapping, userLanguage: string = "en"): Observable<IAccountUserMapping> {
        let mapping = accountUserMapping as IAccountUserMappingUpdate;
        mapping.Email = email;

        return this.http.post<IAccountUserMapping>(`/api/userAccountMappings/`, mapping, { params: { userLanguage } });
    }

    hasCachedAccountUserMappings(): boolean {
        return this.sessionService.getItem<IAccountUserMapping[]>(SettingsName.AccountUserMappings)?.length > 0;
    }

    updateCachedAccountUserMapping(userId: number, replacementMapping: IAccountUserMapping): boolean {
        if (!this.hasCachedAccountUserMappings()) {
            return false;
        }

        const cachedAccountUserMappings: IAccountUserMapping[] = { ...this.sessionService.getItem(SettingsName.AccountUserMappings) };
        const currentAccountUserMappingIndex = cachedAccountUserMappings.findIndex(mapping => mapping.UserId === userId);

        if (currentAccountUserMappingIndex === -1) {
            return false;
        }

        cachedAccountUserMappings[currentAccountUserMappingIndex] = replacementMapping;

        this.sessionService.setItem(SettingsName.AccountUserMappings, cachedAccountUserMappings);
    }
    //--

    private formatMappings(mappings: IAccountUserMapping[]): IAccountUserMapping[] {

        if (this.isDemoSite) {
            mappings.forEach(mapping => {
                mapping.Name = this.translationService.t('currentUserService.demo');
            })
        }

        return mappings;
    }
}
